import React from "react";
import IntegrationTimeline from "../../../../../../common/components/integration-timeline/IntegrationTimeline";
import { useTimelineStepPermissions } from "../../../../../../hooks/useTimelineStepPermissions";
import { Integration } from "../../../../../../redux/slices/projects/Types";
import {
  buildIntegrationMilestones,
  getTimelineCompletionPercent,
} from "../utils/buildIntegrationMilestones";
import "./ProjectTimelineBlock.scss";

type ProjectTimelineBlockProps = {
  integration: Integration;
};

const ProjectTimelineBlock: React.FC<ProjectTimelineBlockProps> = ({
  integration,
}) => {
  const { canAccessTimeline } = useTimelineStepPermissions();
  const milestones = React.useMemo(
    () => buildIntegrationMilestones(integration),
    [integration]
  );
  const completionPercent = getTimelineCompletionPercent(milestones);

  if (!canAccessTimeline) {
    return null;
  }

  return (
    <div className="project-timeline-block">
      <div className="project-timeline-block__header">
        <h3 className="project-timeline-block__title">Timeline</h3>
      </div>

      <div className="project-timeline-block__content">
        <div className="project-timeline-block__body">
          <IntegrationTimeline
            milestones={milestones}
            className="integration-timeline--project-details"
            pendingLabel="Not Started"
          />
        </div>
        <div className="project-timeline-block__meta">
          <span className="project-timeline-block__percent">
            {completionPercent}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProjectTimelineBlock;
